<template lang="html">
  <menu class="menu" ref="menu">
    <b-link
      ref="Discover"
      class="menu__item"
      :to="{ name: 'DiscoverCapsules' }"
      style="--bgColorItem: #6ce1c5;"
    >
      <SvgDiscover />
    </b-link>

    <b-link
      ref="Blog"
      :to="{ name: 'Blog' }"
      class="menu__item"
      style="--bgColorItem: #f54888;"
      exact
    >
      <SvgBlog />
    </b-link>

    <b-link
      ref="Community"
      :to="{ name: 'Community' }"
      class="menu__item"
      style="--bgColorItem: #695CE0;"
      exact
    >
      <SvgCommunity />
    </b-link>

    <button
      ref="five"
      @click.stop="clickOpenAuthModal"
      class="menu-button menu__item"
      style="--bgColorItem:#FFCC00;"
    >
      <SvgLogin />
    </button>

    <div
      class="menu__border"
      ref="menuBorder"
      :class="{ 'zero-opacity': hideMenuBorder }"
    ></div>
  </menu>
</template>

<script>
import SvgDiscover from "./svgs/SvgDiscover";
import SvgCommunity from "./svgs/SvgCommunity";
import SvgBlog from "./svgs/SvgBlog";
import SvgLogin from "./svgs/SvgLogin";
import { mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  components: {
    SvgDiscover,
    SvgCommunity,
    SvgBlog,
    SvgLogin,
  },

  data() {
    return {
      hideMenuBorder: false,
    };
  },

  mounted() {
    this.$nextTick(this.routeLoaded);
  },

  methods: {
    clickOpenAuthModal() {
      bus.$emit("openSignUpModal");
    },

    routeLoaded() {
      const routeName =
        this.$router.currentRoute.name !== null &&
        this.$router.currentRoute.name.toLowerCase().includes("discover")
          ? "Discover"
          : this.$router.currentRoute.name;

      const ref = this.$refs[routeName];

      if (ref) {
        this.hideMenuBorder = false;
        let box = ref.$el.getBoundingClientRect();
        this.offsetMenuBorder(box);
      } else {
        this.hideMenuBorder = true;
      }
    },

    offsetMenuBorder(box) {
      let menuBorder = this.$refs.menuBorder;
      let left =
        Math.floor(
          box.left -
            this.$refs.menu.offsetLeft -
            (menuBorder.offsetWidth - box.width) / 2
        ) + "px";
      menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
    },
  },

  computed: {
    ...mapGetters(["currentUser"]),

    currentUsername() {
      if (this.currentUser) {
        return this.currentUser.username;
      }
    },
  },

  watch: {
    $route() {
      this.$nextTick(this.routeLoaded);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.menu {
  display: flex;
  // width: 32.05em;
  width: 100%;
  font-size: 1.5em;
  padding: 0 2.85em;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: var(--bgColorMenu);
  margin-bottom: 0;
}

.menu__item {
  // all: unset;
  flex-grow: 1;
  z-index: 100;
  display: flex;
  cursor: pointer;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 0.55em 0 0.85em;
  transition: transform var(--duration);

  &.menu-button {
    border: none;
    background: $primary-blue;
  }
}

.menu__item::before {
  content: "";
  z-index: -1;
  width: 4.2em;
  height: 4.2em;
  border-radius: 50%;
  position: absolute;
  transform: scale(0);
  transition: background-color var(--duration), transform var(--duration);
}

.menu__item.router-link-active {
  transform: translate3d(0, -0.8em, 0);
}

.menu__item.router-link-active::before {
  transform: scale(1);
  background-color: var(--bgColorItem);
}

.icon {
  width: 2.6em;
  height: 2.6em;
  stroke: white;
  fill: transparent;
  stroke-width: 1pt;
  stroke-miterlimit: 10;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 400;
}

.menu__border {
  left: 0;
  bottom: 99%;
  width: 10.9em;
  height: 2.4em;
  position: absolute;
  clip-path: url(#menu);
  background-color: var(--bgColorMenu);
  transition: transform var(--duration);
  opacity: 1;

  &.zero-opacity {
    opacity: 0;
  }
}

.svg-container {
  width: 0;
  height: 0;
}

@media screen and (max-width: 50em) {
  .menu {
    font-size: 0.8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar/MobileNavbarGuest.vue